import { combineReducers } from "redux";
import createNamedWrapperReducer from "@redux/feature/Markets/Equity/wrapperReducer";
import ClientSearchReducer from "./reducer/clientSearchReducer";
import ClientHeaderAccCodeReducer from "./reducer/clientHeaderAccCode";
import clientOverviewReducer from "./reducer/clientOverview";
import ClientMultipleContacts from "./reducer/clientMultipleContacts";
import ClientMCAccess from "./reducer/clientMCAccess";
import PasswordResentHistory from "./reducer/passwordResentHistory";
import OwnerHistoryReducer from "./reducer/ownerHistory";
import DpDetailsReducer from "./reducer/dpDetails";
import BankDetailsReducer from "./reducer/bankDetails";
import RevAUMDataReducer from "./reducer/revenueAUMData";
import ClientHeaderAUMReducer from "./reducer/clientHeaderAUM";
import HistoricalViewReducer from "./reducer/historicalView";
import ClientPassthroughReducer from "./reducer/clientPassthrough";
import ClientBackOfficeUrlReducer from "./reducer/clientBackOfficeUrl";
import MFRegistrationBookReducer from "./reducer/mfRegistrationBook";
import RevActiveLoansReducer from "./reducer/revenueActiveLoans";
import FamilyMemDetailsReducer from "./reducer/familyMemDetails";
import MFOrderBookReducer from "./reducer/mfOrderBook";
import GetExceptionlsinReducer from "./reducer/GetExceptionlsin";
export default combineReducers({
    ClientSearch: createNamedWrapperReducer(ClientSearchReducer, "ClientSearch"),
    ClientHeaderAccCode: createNamedWrapperReducer(ClientHeaderAccCodeReducer, "ClientHeaderAccCode"),
    ClientHeaderAUM: createNamedWrapperReducer(ClientHeaderAUMReducer, "clientHeaderAUM"),
    ClientOverview: createNamedWrapperReducer(clientOverviewReducer, "ClientOverview"),
    ClientMultipleContact: createNamedWrapperReducer(ClientMultipleContacts, "ClientMultipleContact"),
    ClientMCAccess: createNamedWrapperReducer(ClientMCAccess, "ClientMCAccess"),
    PasswordResentHistory: createNamedWrapperReducer(PasswordResentHistory, "PasswordResentHistory"),
    OwnerHistoryReducer: createNamedWrapperReducer(OwnerHistoryReducer, "OwnerHistory"),
    DPDetails: createNamedWrapperReducer(DpDetailsReducer, "DPDetails"),
    BankDetails: createNamedWrapperReducer(BankDetailsReducer, "BankDetails"),
    AUMData: createNamedWrapperReducer(RevAUMDataReducer, "AUMData"),
    activeLoans: createNamedWrapperReducer(RevActiveLoansReducer, "activeLoans"),
    HistoricalView: createNamedWrapperReducer(HistoricalViewReducer, "HistoricalView"),
    ClientPassthrough: createNamedWrapperReducer(ClientPassthroughReducer, "ClientPassthrough"),
    ClientBackOfficeUrl: createNamedWrapperReducer(ClientBackOfficeUrlReducer, "ClientBackOfficeUrl"),
    MFRegistartionBook: createNamedWrapperReducer(MFRegistrationBookReducer, "MFRegistrationBook"),
    MFOrderBook: createNamedWrapperReducer(MFOrderBookReducer, "MFOrderBook"),
    FamilyMemDetails: createNamedWrapperReducer(FamilyMemDetailsReducer, "FamilyMemDetails"),
    GetExceptionlsin: createNamedWrapperReducer(GetExceptionlsinReducer, "GetExceptionlsin"),
});
